import * as ActionTypes from '../actions/actionTypes';
import {addDays, flooredHour, lastMidnightDate} from '../utils/time_utils';

const ONE_HOUR_IN_MILLISECONDS = 3600000;
const ONE_DAY_IN_MILLISECONDS = 86400000;

const start_selected_time = flooredHour(new Date());
const start_valid_from = addDays(lastMidnightDate(start_selected_time), -2);
const start_valid_to = addDays(lastMidnightDate(start_selected_time), 7);

const _eachPeriodBetween = (first_time, last_time, period) => {
  last_time = last_time || addDays(first_time, 7);
  let parsed_first_time = Date.parse(first_time);
  let parsed_last_time = Date.parse(last_time);
  let time_between_first_and_last_times = parsed_last_time - parsed_first_time;
  let periods_between_first_and_last_times = Math.floor(time_between_first_and_last_times / period);
  let interpolated_times = [];
  for (let i = 0; i < periods_between_first_and_last_times; i++) {
    interpolated_times.push(new Date(parsed_first_time + (i * period)).toISOString());
  }
  return (interpolated_times);
};

const initialState = {
  selected_time: flooredHour(new Date()),
  valid_times: _eachPeriodBetween(start_valid_from, start_valid_to, ONE_HOUR_IN_MILLISECONDS),
  valid_days: _eachPeriodBetween(start_valid_from, start_valid_to, ONE_DAY_IN_MILLISECONDS),
  display_time: undefined
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_TIME:
      return {
        ...state,
        selected_time: new Date(action.selected_time).toISOString()
      };
    case ActionTypes.SET_DISPLAY_TIME:
      const display_time = action.display_time ? new Date(action.display_time).toISOString() : action.display_time;
      return {
        ...state,
        display_time: display_time
      };
    case ActionTypes.POPULATE_VALID_TIMES:
      return {
        ...state,
        valid_times: _eachPeriodBetween(lastMidnightDate(action.from_time),
          addDays(lastMidnightDate(action.from_time), 7),
          ONE_HOUR_IN_MILLISECONDS),
        valid_days: _eachPeriodBetween(lastMidnightDate(action.from_time),
          addDays(lastMidnightDate(action.from_time), 7),
          ONE_DAY_IN_MILLISECONDS)
      };
    case ActionTypes.SET_TIMELINE_NOW:
      return {
        ...state,
        selected_time: flooredHour(new Date())
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/time.js